import { TechnologyData } from "../technology";
import { createValuesFor, setValue } from "../../__mock__/calculation-values";

export default {
  id: "xline",
  name: "Xline",
  oneliner: "Pre-engineered solution",
  image: "/images/technologies/XLine.jpg",
  techImage: [
    "/images/tech_images/X-line/X-line.png",
    "/images/tech_images/X-line/Pentair X-Line comp_01.png",
    "/images/tech_images/X-line/Pentair X-Line comp_02.png",
    "/images/tech_images/X-line/Pentair X-Line comp_03.png",
    "/images/tech_images/X-line/Pentair X-Line comp_04.png"
  ],
  active: true,
  comparableTechnologies: ["xline", "xiga", "aquaflex"],
  description:
    "The revolutionary pre-engineered Ultrafiltration solution with maximum flexibility in rack designand   a   minimum   footprint.   This   plug   &   play   concept  uses   OptiFlow   caps   for   smart   flowoptimization and unprecedented cost-effectiveness.",
  values: [
    ...createValuesFor("design.details", [
      // Detailed feed parameters
      setValue("account_name", ["Partner2"]),
      setValue("opportunity_number", ["OP-2345671"]),
      setValue("project_name", ["UF Water treatment"]),
      setValue("project_destination", ["India"]),
      setValue("designer", ["Karthi Pitchaikani"]),
      setValue("approver", ["-"])
    ]),
    ...createValuesFor("input.feed.detailed", [
      // Detailed feed parameters
      setValue("temperature_range", [15, 35]),
      setValue("ph_range", [7.8, 8.2]),
      setValue("calcium", [410]),
      setValue("ammonia", [1]),
      setValue("phosphorus", [1])
    ]),
    ...createValuesFor("input.water.main", [
      // Main water parameters
      setValue("design_turbidity", [10]),
      setValue("temperature", [20]),
      setValue("turbidity", [10]),
      setValue("tss", [10]),
      setValue("toc", [3]),
      setValue("cod", [5]),
      setValue("color", [10]),
      setValue("alkanity", [130]),
      setValue("ph", [7.2]),
      setValue("tds", [40000]),
      setValue("hardness", [6900])
    ]),
    ...createValuesFor("input.plant.capacity", [
      // Plant Capacity
      setValue("water_source", ["Sea water"]),
      setValue("capacity_base", ["Permeate production"]),
      setValue("capacity", [1000]),
      setValue("temperature", [20])
    ]),
    ...createValuesFor("input.plant.membrane", [
      //
      setValue("membrane")
    ]),
    ...createValuesFor("plant.configuration", [
      setValue("total_units", [4]),
      setValue("xlr_rows", [4]),
      setValue("shorter_rows", [0]),
      setValue("membrane_elements", [13], undefined, "per row"),
      setValue("total_membrane_elements", [208]),
      setValue("spare_membrane_elements", [0]),
      setValue("membrane_element", ["XF64"]),
      setValue("total_mebrane_area", [13313]),
      setValue("backwash_trains", [1])
    ]),
    ...createValuesFor("plant.configuration.image", [
      setValue("avg_feed_flow", [1046.8]),
      setValue("fecl3_dosing_pump", [5.6]),
      setValue("feed_pumps", [1098.2]),
      setValue("backwash_pumps", [798.7]),
      setValue("net_permeate_flow", [1000]),
      setValue("total_concentrate_flow", [46.8]),
      setValue("avg_backwash_flow", [22.5]),
      setValue("avg_forward_flush_flow", [17.1]),
      setValue("avg_ceb_1_flow", [7.2])
    ]),
    ...createValuesFor("results", [
      // Calculated results
      setValue("gross_filtration_flux", [82.5]),
      setValue("filtration_time", [50]),
      setValue("net_filtration_flux", [75.1]),
      setValue("avg_ceb_1_counter", [24.2]),
      setValue("ceb_1_counter", [27]),
      setValue("recovery", [95.9])
    ]),
    ...createValuesFor("results.pump.naocl", [
      // Calculated results
      setValue("naocl_dosing_pump", [798.7]),
      setValue("naocl_consumption", [27.0])
    ]),
    ...createValuesFor("results.pump.naoh", [
      // Calculated results
      setValue("naoh_dosing_pump", [180.4]),
      setValue("naoh_consumption", [6.1])
    ]),
    ...createValuesFor("results.pump.h2so4", [
      // Calculated results
      setValue("h2so4_dosing_pump", [279.9]),
      setValue("h2so4_consumption", [9.5])
    ]),
    setValue("uf_feed_pump", [1042.8]),
    setValue("fecl3_coagulant_pump", [5.6])
  ],
  techImageMap: [
    {
      title: "Plant configuration",
      titleVariant: "big",
      location: [3, 0],
      rotation: 0,
      width: 250,
      align: "left",
      values: [
        "total_units",
        "xlr_rows",
        "shorter_rows",
        "membrane_elements",
        "total_membrane_elements",
        "spare_membrane_elements",
        "membrane_element",
        "total_mebrane_area",
        "backwash_trains"
      ]
    },
    {
      title: null,
      values: ["avg_feed_flow"],
      location: [5, 74],
      rotation: -14,
      width: 160,
      info: null,
      align: "left",
      titleVariant: "small"
    },
    {
      title: null,
      values: ["fecl3_dosing_pump"],
      location: [27, 81],
      rotation: 0,
      width: 120,
      align: "left",
      titleVariant: "small"
    },
    {
      title: null,
      values: ["feed_pumps"],
      location: [18, 63],
      rotation: 0,
      width: 160,
      align: "left",
      titleVariant: "small"
    },
    {
      title: "NaOCL CEB",
      values: ["naocl_dosing_pump", "naocl_consumption"],
      location: [40, 5],
      rotation: 0,
      width: 170,
      align: "left",
      titleVariant: "small"
      // line: "M 1 1 1 30 l50 30"
    },
    {
      title: "NaOH CEB",
      values: ["naoh_dosing_pump", "naoh_consumption"],
      location: [52, 2.5],
      rotation: 0,
      width: 170,
      align: "left",
      titleVariant: "small"
    },
    {
      title: "H₂SO₄ CEB",
      values: ["h2so4_dosing_pump", "h2so4_consumption"],
      location: [64, 0],
      rotation: 0,
      width: 170,
      align: "left",
      titleVariant: "small"
    },
    {
      title: null,
      values: ["backwash_pumps"],
      location: [69, 35],
      rotation: 0,
      width: 120,
      align: "left",
      titleVariant: "small"
    },
    {
      title: null,
      values: ["net_permeate_flow"],
      location: [90, 18],
      rotation: -10,
      width: 110,
      titleVariant: "small"
    },
    {
      title: "Concentrate",
      values: ["total_concentrate_flow", "avg_forward_flush_flow", "avg_backwash_flow", "avg_ceb_1_flow"],
      location: [84, 68],
      rotation: 0,
      width: 250,
      align: "right",
      info: null,
      titleVariant: "small"
      // line: "M250 1 20 30 250 -200"
    }
  ]
} as TechnologyData;
